import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource} from "kea-resource";

const controller = rpcController("DiarioVenta");

/**Resource del reporte de estadísticas de clientes*/
export const RepDiarioVentas = cacheResource({
    Generar: async (
        parametros: models.ParamsDiarioVenta): Promise<string> =>
        await controller("GenerarReporteDiarioVenta", {}, parametros)
}, {
    }, {
})


// WEBPACK FOOTER //
// ./app/resources/items/diarioventa.tsx